import React, { useState } from 'react';

const TAB_PROBLEMS = 'problems';
const TAB_PAUSE = 'pause';

export default function UcatPearsonHelpOverlay({ onClose }) {
  const [tab, setTab] = useState(TAB_PROBLEMS);
  const th = {
    border: '1px solid #000',
    padding: '8px 10px',
    textAlign: 'left',
    verticalAlign: 'top',
    fontWeight: 700,
    width: '28%',
    background: '#fff',
  };
  const td = {
    border: '1px solid #000',
    padding: '8px 10px',
    textAlign: 'left',
    verticalAlign: 'top',
    background: '#fff',
  };

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label="Help"
      className="ucat-pearson-help-overlay"
      style={{
        position: 'absolute',
        inset: 24,
        zIndex: 50,
        background: '#FFFFFF',
        border: '2px solid #006DAA',
        boxShadow: '0 10px 28px rgba(0,0,0,0.25)',
        display: 'flex',
        flexDirection: 'column',
        fontFamily: 'Tahoma, Arial, Helvetica, sans-serif',
        color: '#000',
      }}
    >
      <style>{`
        @media (max-width: 768px) {
          .ucat-pearson-help-overlay {
            position: fixed !important;
            inset: 0 !important;
            border-width: 0 !important;
          }
          .ucat-pearson-help-overlay table {
            display: block !important;
          }
          .ucat-pearson-help-overlay tbody,
          .ucat-pearson-help-overlay tr {
            display: block !important;
          }
          .ucat-pearson-help-overlay th,
          .ucat-pearson-help-overlay td {
            display: block !important;
            width: 100% !important;
            box-sizing: border-box !important;
          }
        }
      `}</style>
      <div style={{ display: 'flex', alignItems: 'stretch', background: '#006DAA', color: '#fff', height: 36 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '0 12px', fontWeight: 700 }}>
          Help
        </div>
        <div style={{ display: 'flex', marginLeft: 8 }}>
          <button
            type="button"
            onClick={() => setTab(TAB_PROBLEMS)}
            style={{
              background: tab === TAB_PROBLEMS ? '#FFFFFF' : '#4678BE',
              color: tab === TAB_PROBLEMS ? '#000' : '#fff',
              border: 'none',
              padding: '0 14px',
              fontWeight: 700,
              cursor: 'pointer',
            }}
          >
            Test Problems
          </button>
          <button
            type="button"
            onClick={() => setTab(TAB_PAUSE)}
            style={{
              background: tab === TAB_PAUSE ? '#FFFFFF' : '#4678BE',
              color: tab === TAB_PAUSE ? '#000' : '#fff',
              border: 'none',
              padding: '0 14px',
              fontWeight: 700,
              cursor: 'pointer',
            }}
          >
            Pause The Clock Breaks
          </button>
        </div>
        <button
          type="button"
          aria-label="Close help"
          onClick={onClose}
          style={{ marginLeft: 'auto', background: 'transparent', border: 'none', color: '#fff', fontSize: 18, padding: '0 12px', cursor: 'pointer' }}
        >
          ×
        </button>
      </div>
      <div style={{ flex: 1, overflow: 'auto', padding: 16, fontSize: 14, lineHeight: 1.45 }}>
        {tab === TAB_PROBLEMS ? (
          <>
            <p style={{ margin: '0 0 12px', fontWeight: 700 }}>TEST PROBLEMS</p>
            <p style={{ margin: '0 0 12px' }}>
              Test time will continue to count down while using the Help button.
            </p>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
              <tbody>
                <tr>
                  <th style={th}>Problems with your test or environment</th>
                  <td style={td}>
                    If something on screen does not look right, or you cannot continue, use Next / Previous / Navigator with the mouse.
                    Do not share, copy, or publish any item from this sitting.
                  </td>
                </tr>
                <tr>
                  <th style={th}>Problems with your health or wellbeing during testing</th>
                  <td style={td}>
                    Stop if you are unwell. This practice sitting does not replace test-centre invigilation.
                    If you choose to continue, you do so at your own pace.
                  </td>
                </tr>
                <tr>
                  <th style={th}>Calculator troubleshooting</th>
                  <td style={td}>
                    <ul style={{ margin: 0, paddingLeft: 18 }}>
                      <li>Use ON/C or close and reopen the calculator to reset it.</li>
                      <li>If the number pad does not work, use the mouse on the calculator buttons.</li>
                      <li>Clicking away from the calculator window (or Flag for Review) disables it until you click the window again.</li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <th style={th}>Notebook or pen</th>
                  <td style={td}>
                    We do not provide a laminated notepad in this practice sitting. You may use your own paper.
                  </td>
                </tr>
                <tr>
                  <th style={th}>Issues with keyboard shortcuts</th>
                  <td style={td}>
                    If Alt shortcuts do not work on your device, use the mouse. Screen magnification is your browser zoom (Ctrl + / − / 0).
                  </td>
                </tr>
              </tbody>
            </table>
          </>
        ) : (
          <>
            <p style={{ margin: '0 0 12px', fontWeight: 700 }}>PAUSE THE CLOCK BREAKS</p>
            <p style={{ margin: '0 0 12px' }}>
              This practice sitting does not include a Pause Exam control. Timed sections keep running until you finish them or the section time ends.
            </p>
            <p style={{ margin: 0 }}>
              Rest-break arrangements that exist in a live test centre are not part of this player. Use Help to read this note; the countdown will still tick.
            </p>
          </>
        )}
      </div>
    </div>
  );
}
